import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppServiceService } from 'src/app/api/app-service.service';
import { DatePipe } from '@angular/common';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-order-summery',
  templateUrl: './order-summery.page.html',
  styleUrls: ['./order-summery.page.scss'],
})
export class OrderSummeryPage implements OnInit {
  @Input() webUniqueId: string = '';

  checkOrder: boolean = true;
  unique: any = '';
  orderInfo: any;
  essenRate: number = 0;
  lifebernRate: number = 0;
  reviewText: string = '';
  // This array will decide how many starts display for ratings
  stars = [1, 2, 3, 4, 5];
  reviewErrors: any = null;
  // to check wether user has left a review or not
  hasLeftaReview: boolean = false;
  // the message receive after saving review
  reviewSuccess: string = '';

  orderDeliveryDate: any;
  orderDeliveryTime: any;

  totalTaxAmount = 0;

  public isPointsEnabled: string = '';

  // current order uber status
  public uberStatus = 'waiting_for_pickup';

  // this will control the new re order same feature
  // we won't allow old orders to reorder so compare the app version before enabling this feature
  public displayReOrderButton:boolean = false;

  public uberDeliveryStatus:any[] = [];
  public currentStatusIndex:number = 0;

  // display uber delivery status timeline expanded
  public showTimeLine:boolean = false;

  constructor(public appService: AppServiceService, private route: ActivatedRoute, private datePipe: DatePipe, private router: Router, private modelController: ModalController) {

    setTimeout(() => {
      this.appService.appObject.isLoading = true;
    }, 10);

    this.route.params.subscribe((param) => {
      this.unique = param.unique;
    });

    // when open order summary page from web app
    setTimeout(() => {
      if (this.appService.isWebVersion && this.webUniqueId) this.unique = this.webUniqueId;
    }, 10);
  }

  ngOnInit() {
  }

  // ionViewDidEnter() {

  //   setTimeout(() => {
  //     this.getOrderInfo();
  //   }, 500);
  //   setInterval(() => {
  //     if (this.checkOrder) {
  //       this.getOrderInfo();
  //     }
  //   }, 2000);


  // }
  ngAfterViewInit() {
    setTimeout(() => {
      this.getOrderInfo();
    }, 500);
    // setInterval(() => {
    //   if (this.checkOrder) {
    //     this.getOrderInfo();
    //   }
    // }, 2000);
  }

  ionViewWillEnter() {
  }

  ionViewWillLeave() {
    // console.log('leaveng');
    this.checkOrder = false;
  }

  ngOnDestroy() {
    this.checkOrder = false;
  }

  async getOrderInfo() {
    this.appService.getOrderInfo(this.unique).then(data => {
      if (data.status) {
        this.orderInfo = data.data;

        if (this.orderInfo.delivery_time_resturent) {
          var dateTimeArr = this.orderInfo.delivery_time_resturent.split(" ");
          this.orderDeliveryDate = dateTimeArr[0];
          this.orderDeliveryTime = dateTimeArr[1];
        }

        if (this.orderInfo.review) {
          this.hasLeftaReview = true;
          this.essenRate = this.orderInfo.order_review_stars;
          this.lifebernRate = this.orderInfo.order_review_delivery_type_stars;
          this.reviewText = this.orderInfo.review;
        }

        if (this.orderInfo.status == 'rejected' || this.orderInfo.status == 'completed') {
          this.checkOrder = false;
        }

        // console.log(this.orderInfo.restaurantDetails);
        if (!this.isPointsEnabled && this.orderInfo.restaurantDetails && this.orderInfo.restaurantDetails.payment_methods) {
          let paymentMethods = JSON.parse(this.orderInfo.restaurantDetails.payment_methods);
          if (paymentMethods && paymentMethods.length) {
            let points = paymentMethods.find((method) => method.id === 'points');
            this.isPointsEnabled = points.isActive === 'true' ? 'true' : 'false';
          }
        }

        this.orderInfo.tip_amount = this.orderInfo.tip_amount ? this.orderInfo.tip_amount : 0;


        // check the order app_version to allow re order the same items 
        if(this.orderInfo.app_version && [1,0].includes(this.appService.compareVersions(this.orderInfo.app_version,'5.2.8'))){
          this.displayReOrderButton = true;
        }

        // get total tax amount to display instead of tax type
        this.totalTaxAmount = ((this.orderInfo.total_tax_inclusive ? this.orderInfo.total_tax_inclusive : 0) + (this.orderInfo.total_tax_exclusive ? this.orderInfo.total_tax_exclusive : 0));

        this.orderInfo.uber_delivery_details = this.orderInfo.uber_delivery_details ? JSON.parse(this.orderInfo.uber_delivery_details) : null;
        
        // console.log('this.orderInfo.uber_delivery_details: ' ,this.orderInfo.uber_delivery_details);
        
        this.uberDeliveryStatus = [];
        this.currentStatusIndex = 0;
        // START tracking details
        if(this.orderInfo.uber_delivery_details){
          this.uberDeliveryStatus.push({
            status: 'rider_accepted',
            time: null,
            date: null,
            subText: 'uber_rider_accepted_your_delivery_request'
          });

          if(this.orderInfo.uber_delivery_details.rider_accepted){
            let split = this.orderInfo.uber_delivery_details.rider_accepted.split(' ');
            this.uberDeliveryStatus[0].date = split[0];
            this.uberDeliveryStatus[0].time = split[1];
            this.currentStatusIndex = 0;
          }
          this.uberDeliveryStatus.push({
            status: 'rider_pickedup',
            time: null,
            date: null,
            subText: 'uber_rider_picked_up_the_order_to_deliver'
          });

          if(this.orderInfo.uber_delivery_details.rider_pickedup){
            let split = this.orderInfo.uber_delivery_details.rider_pickedup.split(' ');
            this.uberDeliveryStatus[1].date = split[0];
            this.uberDeliveryStatus[1].time = split[1];
            this.currentStatusIndex = 2;
          }

          this.uberDeliveryStatus.push({
            status: 'delivering',
            time: null,
            date: null,
            subText: 'your_order_is_on_the_way'
          })

          this.uberDeliveryStatus.push({
            status: 'rider_one_minute_away',
            time: null,
            date: null,
            subText: 'rider_is_one_minute_away_from_the_drop_off_location'
          });

          if(this.orderInfo.uber_delivery_details.rider_nearby){
            let split = this.orderInfo.uber_delivery_details.rider_nearby.split(' ');
            this.uberDeliveryStatus[3].date = split[0];
            this.uberDeliveryStatus[3].time = split[1];
            this.currentStatusIndex = 3;
          }

          // if(this.orderInfo.uber_delivery_details.rider_delivered){
          //   this.uberDeliveryStatus.push({
          //     status: 'returned',
          //     time: this.orderInfo.uber_delivery_details.rider_delivered
          //   });
          //   this.currentStatusIndex = 3;
          // }

          this.uberDeliveryStatus.push({
            status: 'delivered',
            time: this.orderInfo.uber_delivery_details.rider_delivered,
            subText: 'rider_confirmed_the_order_has_been_delivered'
          });

          if(this.orderInfo.uber_delivery_details.rider_delivered){
            let split = this.orderInfo.uber_delivery_details.rider_delivered.split(' ');
            this.uberDeliveryStatus[4].date = split[0];
            this.uberDeliveryStatus[4].time = split[1];
            this.currentStatusIndex = 4;
          }
        }
        // END tracking details
        console.log('uberDeliveryStatus: ' , this.uberDeliveryStatus);
        // console.log('currentStatusIndex: ' , this.currentStatusIndex);
      }
      this.appService.appObject.isLoading = false;
    }, error => {
      this.appService.appObject.isLoading = false;
    }).finally(() =>{
      // keep updating order details till order completed / rejected
      if(this.checkOrder){
        setTimeout(() => {
          this.getOrderInfo();
        }, 5000);
      }
    });
  }

  /**
   * Save user review
   */
  saveUserReview() {
    if (this.orderInfo.payment_id) {
      this.reviewErrors = null;
      this.appService.appObject.isLoading = true;
      let reviewData = {
        payment_id: this.orderInfo.payment_id,
        review_text: this.reviewText,
        order_review_stars: this.essenRate,
        order_review_delivery_type_stars: this.lifebernRate
      };
      // console.log('Review Data :  ', reviewData);
      this.appService.insertUserReview(reviewData).then((response: any) => {
        // console.log('Review Response : ', response);

        if (response.status) {
          this.reviewSuccess = response.msg;
          this.hasLeftaReview = true;
          // set a time out to clear review success message
          setTimeout(() => {
            this.reviewSuccess = '';
          }, 5000);
        } else {
          this.reviewErrors = response.msg;
        }

        this.appService.appObject.isLoading = false;
      }).catch((error) => {
        console.log('error (leaving user review) : ', error);
        this.appService.appObject.isLoading = false;
      });
    }
  }

  /**
   * When user tap on order again in order summary
   */
  orderAgain() {
    this.router.navigate([this.appService.isWebVersion ? ('/menu/' + this.orderInfo.restaurantDetails.slug) : ('/restaurant/' + this.orderInfo.restaurantDetails.slug)])
    // if this is web version, then close the modal dialog
    if (this.appService.isWebVersion) this.appService.modalDismiss();
  }

  /**
   * Order the same dishes as in the details again
   */
  async sameOrderAgain() {
    // console.log('orderInfo:  ' , this.orderInfo);
    this.appService.appObject.reOrderObject = {
      items: this.orderInfo.items,
      restaurant_slug: this.orderInfo.restaurantDetails.slug
    }

    // clear cart if there are any items already in
    await this.appService.clearCart();
    
    await this.appService.updateAppObject();

    // router configurations are same for both web and mobile routes
    // so define here for reuse
    let routeConfig = {
      queryParams: {
        re_order: true,
      },
      replaceUrl: true
    }

    if (this.appService.isWebVersion) {
      await this.router.navigate(['/blank-page']);
      this.router.navigate(['/menu/' + this.orderInfo.restaurantDetails.slug], routeConfig)
    } else {
      this.router.navigate(['/restaurant/' + this.orderInfo.restaurantDetails.slug], routeConfig)
    }

    this.modelController.dismiss();
  }

}
